import gettext from '@sdk/lang/gettext';

import { FeatureNames } from '@web/account/types';
import shiftSwapIcon from '@web/assets/svg/Icons/32/shift-swap-gray.svg';
import autoAssignIcon from '@web/assets/svg/Icons/32/auto-assign-gray.svg';
import lateArrivalIcon from '@web/assets/svg/Icons/32/late-arrival-gray.svg';
import sickCalloutIcon from '@web/assets/svg/Icons/32/sick-callout-gray.svg';

import timeClockIcon from '../../assets/svg/Icons/32/timesheet-gray.svg';
import laborCostIcon from '../../assets/svg/Icons/32/labor-gray.svg';
import reportsIcon from '../../assets/svg/Icons/32/reports-gray.svg';
import tagsIcon from '../../assets/svg/Icons/32/tag-gray.svg';
import scheduleTemplatesIcon from '../../assets/svg/Icons/32/shift-gray.svg';
import ptoIcon from '../../assets/svg/Icons/32/shift-leave-gray.svg';
import noShowIcon from '../../assets/svg/Icons/32/no-show-gray.svg';
import slotsIcon from '../../assets/svg/Icons/32/shift-available-gray.svg';
import googleSyncIcon from '../../assets/svg/Icons/32/calendarsync-gray.svg';
import businessClosedIcon from '../../assets/svg/Icons/32/business-closed-gray.svg';
import messagesIcon from '../../assets/svg/Icons/32/message-gray.svg';
import shiftTasksIcon from '../../assets/svg/Icons/32/task-gray.svg';
import overtimeIcon from '../../assets/svg/Icons/32/open-ended-gray.svg';

export type PremiumFeatureDescription = {
  key: FeatureNames;
  title: string;
  icon: React.ComponentType;
};

export const businessFeatureDefinitions: PremiumFeatureDescription[] = [
  { key: FeatureNames.kiosk, title: gettext('Kiosk time tracking'), icon: timeClockIcon },
  { key: FeatureNames.salaries, title: gettext('Salary support'), icon: laborCostIcon },
  {
    key: FeatureNames.noShow,
    title: gettext('No shows'),
    icon: noShowIcon,
  },
  { key: FeatureNames.lateArrival, title: gettext('Late Arrivals'), icon: lateArrivalIcon },
  {
    key: FeatureNames.autoAssigning,
    title: gettext('Auto assigning'),
    icon: autoAssignIcon,
  },
  { key: FeatureNames.reports, title: gettext('Reports'), icon: reportsIcon },
  { key: FeatureNames.sickCallout, title: gettext('Sick callouts'), icon: sickCalloutIcon },
  { key: FeatureNames.shiftTasks, title: gettext('Task management'), icon: shiftTasksIcon },
];

export const premiumFeatureDescription: PremiumFeatureDescription[] = [
  // Premium
  { key: FeatureNames.timeclock, title: gettext('Time tracking'), icon: timeClockIcon },
  { key: FeatureNames.budgeting, title: gettext('Budgeting'), icon: laborCostIcon },
  { key: FeatureNames.shiftSwaps, title: gettext('Shift swaps'), icon: shiftSwapIcon },
  { key: FeatureNames.messages, title: gettext('Private and group messaging'), icon: messagesIcon },
  { key: FeatureNames.overtime, title: gettext('Overtime tracking'), icon: overtimeIcon },
  { key: FeatureNames.shiftSlots, title: gettext('Availability'), icon: slotsIcon },
  {
    key: FeatureNames.scheduleTemplates,
    title: gettext('Schedule templates'),
    icon: scheduleTemplatesIcon,
  },
  {
    key: FeatureNames.googleCalendarSync,
    title: gettext('Sync to calendar apps'),
    icon: googleSyncIcon,
  },
  {
    key: FeatureNames.unavailability,
    title: gettext('Unavailability'),
    icon: scheduleTemplatesIcon,
  },
  // Business
  ...businessFeatureDefinitions,
  { key: FeatureNames.leaveTypes, title: gettext('PTO tracking'), icon: ptoIcon },
  { key: FeatureNames.tags, title: gettext('Tags'), icon: tagsIcon },
  {
    key: FeatureNames.businessClosed,
    title: gettext('Business closed'),
    icon: businessClosedIcon,
  },
];
